import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('chayutha')
export class ChayuthaEntity {
  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column("varchar",{
    nullable:false,
    length:500,
    name:"name"
  })
  name: string;  
  @Column("varchar",{
    nullable:true,
    length:500,
    name:"f_or_h_name"
  })
  fatheOrHusbandName: string;
  @Column({
    type:'date',
     nullable:false,
    name:"dod"
  })
  dod:Date;
  @Column({
      type: 'varchar',
      length:500,
      nullable:false,
      name: 'cause_of_death'
  })
  causeOfDeath: string;
  @Column("varchar",{
        nullable:false,
        length:500,
        name:"nominee_name"
  })
  nomineeName:string;
  @Column("varchar",{
    nullable:true,
    length:500,
    name:"family_mem1"
  })
  familyMember1:string;
  @Column("varchar",{
    nullable:true,
    length:500,
    name:"family_mem2"
  })
  familyMember2:string;
  @Column("varchar",{
    nullable:true,
    length:500,
    name:"family_mem3"
  })
  familyMember3:string;
  @Column("varchar",{
    nullable:true,
    length:500,
    name:"family_mem4"
  })
  familyMember4:string;
  @Column("varchar",{
      nullable:false,
      length:250,
      name:"street_name"
  })
  streetName:string;
  
  @Column("varchar",{
        nullable:false,
        length:250,
        name:"village"
  })
  village:string;
  @Column("varchar",{
        nullable:false,
        length:250,
        name:"mandal"
  })
  mandal:string;
  @Column("varchar",{
      nullable:false,
      length:250,
      name:"mobile"
  })
  mobileNo:string;
  @Column("varchar",{
    nullable:false,
    length:250,
    name:"aadhar_no"
  })
  aadharNo:string;
  @Column("varchar",{
  nullable:false,
  length:250,
  name:"village_head_name"
  })
  villageHeadName:string;
  @Column("varchar",{
  nullable:false,
  length:250,
  name:"mandal_head_name"
  })
  mandalHeadName:string;
  @Column("varchar",{
    nullable:true,
    length:250,
    name:"current_status"
    })
    currentStatus:string;
  @Column("boolean",{
      nullable:false,
      default:true,               
      name:"status"
  })
  status:boolean;
  @CreateDateColumn({
        name: "created_at",
        type:"datetime"
  })
  createdAt: Date;
  @Column("int", {
        nullable: false,
        name: "created_user"
  })
  createdUser: number | null;
  @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
  })
  updatedAt: Date;
  @Column("int", {
        nullable: true,
        name: "updated_user"
  })
  updatedUser: number | null;
  @VersionColumn({
          default:1,
          name: "version_flag"
  })
  versionFlag: number;   
   
}